export const testimonials = [
  {
    quoteText:
      "A giant rabbit deals with three annoying rodents in this open-source animated short.",
    citationName: "Big Buck Bunny — Blender Foundation",
    disclaimer: "Open-source film, freely licensed for reuse (CC BY 3.0).",
    videoThumbnailImage: {
      url: "https://placehold.co/505x284/2f6b4f/ffffff?text=Big+Buck+Bunny",
    },
    video: {
      embedUrl: "https://www.youtube-nocookie.com/embed/aqz-KE-bpKQ",
    },
  },
  {
    quoteText:
      "Two characters explore a strange mechanical world in this early open-source 3D short.",
    citationName: "Elephants Dream — Blender Foundation",
    disclaimer: "Open-source film, freely licensed for reuse (CC BY 2.5).",
    videoThumbnailImage: {
      url: "https://placehold.co/505x284/4a5670/ffffff?text=Elephants+Dream",
    },
    video: {
      embedUrl: "https://www.youtube-nocookie.com/embed/TLkA0RELQ1g",
    },
  },
  {
    quoteText:
      "A lone woman searches for a baby dragon she raised and lost, in this fantasy short film.",
    citationName: "Sintel — Blender Foundation",
    disclaimer: "Open-source film, freely licensed for reuse (CC BY 3.0).",
    videoThumbnailImage: {
      url: "https://placehold.co/505x284/8b93a1/ffffff?text=Sintel",
    },
    video: {
      embedUrl: "https://www.youtube-nocookie.com/embed/eRsGyueVLvQ",
    },
  },
];

export default testimonials;
